import { createAction } from "@reduxjs/toolkit";
import {
  HYDRATE_STORYBOARD_SETTINGS_DOMAINS,
  HYDRATE_STORYBOARD_SETTINGS_DRAFT,
  HYDRATE_STORYBOARD_SETTINGS_GATING_CATALOG,
  HYDRATE_STORYBOARD_SETTINGS_STORYBOARD,
  HYDRATE_STORYBOARD_SETTINGS_STORYBOARD_PAGES,
  HYDRATE_STORYBOARD_SETTINGS_USERS,
  RESET_STORYBOARD_SETTINGS,
  RESET_STORYBOARD_SETTINGS_DRAFT,
  SET_STORYBOARD_SETTINGS_ERROR,
  SET_STORYBOARD_SETTINGS_LOADING,
  UPDATE_STORYBOARD_SETTINGS_DRAFT_FIELD,
} from "../actionTypes";
import {
  DomainResponse,
  GatingCatalogRecord,
  StoryboardPageListItem,
  StoryboardUserSummary,
} from "src/types/experiences/storyboardSettings";
import { StoryboardResponse } from "src/types/experiences/storyboardSettings/storyboard";

export type StoryboardSettingsSubKey =
  | "storyboard"
  | "domains"
  | "gatingCatalog"
  | "storyboardPages"
  | "users";

export const hydrateStoryboard = createAction<StoryboardResponse>(
  HYDRATE_STORYBOARD_SETTINGS_STORYBOARD,
);
export const hydrateDomains = createAction<DomainResponse[]>(
  HYDRATE_STORYBOARD_SETTINGS_DOMAINS,
);
export const hydrateGatingCatalog = createAction<GatingCatalogRecord[]>(
  HYDRATE_STORYBOARD_SETTINGS_GATING_CATALOG,
);
export const hydrateStoryboardPages = createAction<StoryboardPageListItem[]>(
  HYDRATE_STORYBOARD_SETTINGS_STORYBOARD_PAGES,
);
export const hydrateUsers = createAction<StoryboardUserSummary[]>(
  HYDRATE_STORYBOARD_SETTINGS_USERS,
);

export const setStoryboardSettingsLoading = createAction<{
  key: StoryboardSettingsSubKey;
  loading: boolean;
}>(SET_STORYBOARD_SETTINGS_LOADING);

export const setStoryboardSettingsError = createAction<{
  key: StoryboardSettingsSubKey;
  error: unknown;
}>(SET_STORYBOARD_SETTINGS_ERROR);

export const hydrateDraft = createAction<StoryboardResponse>(
  HYDRATE_STORYBOARD_SETTINGS_DRAFT,
);

export const updateDraftField = createAction<{
  key: keyof StoryboardResponse;
  value: unknown;
  silent?: boolean;
}>(UPDATE_STORYBOARD_SETTINGS_DRAFT_FIELD);

export const resetDraft = createAction(RESET_STORYBOARD_SETTINGS_DRAFT);

export const resetStoryboardSettings = createAction(RESET_STORYBOARD_SETTINGS);
